/* EclatDent — feed TikTok : lecture auto de la vidéo visible, pause sinon */
(() => {
  if (window.__edTkInit) return;
  window.__edTkInit = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = [...document.querySelectorAll('[data-eda-tk-video]')];
  if (!videos.length) return;

  // Près du viewport : bascule preload none → metadata pour afficher la
  // première image (aperçu) au lieu d'un rectangle noir. 0 Ko hors écran.
  const loadIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const v = e.target;
      if (!v.dataset.loaded) { v.preload = 'metadata'; v.load(); v.dataset.loaded = '1'; }
      loadIO.unobserve(v);
    });
  }, { rootMargin: '600px' });
  videos.forEach((v) => loadIO.observe(v));

  if (reduced) return;

  // Joue la vidéo la plus visible, met les autres en pause.
  const playIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting && e.intersectionRatio > 0.6) {
        const pr = v.play();
        if (pr && pr.catch) pr.catch(() => {});
        v.closest('.eda-tk-card, .edtks-card')?.classList.add('is-playing');
      } else {
        v.pause();
        v.closest('.eda-tk-card, .edtks-card')?.classList.remove('is-playing');
      }
    });
  }, { threshold: [0, 0.6, 1] });
  videos.forEach((v) => playIO.observe(v));
})();
